/* stylelint-disable selector-type-no-unknown */

g-video-banner {
  width: 100%;
}
/* stylelint-enable selector-type-no-unknown */

.g__video-banner {
  display: block;

  &__container {
    cursor: pointer;
    position: relative;

    &:hover {

      .g__video-banner-play {
        opacity: 1;
      }
    }
  }

  &--iframe {
    pointer-events: auto;
    position: static;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }

  &__wrapper {
    margin: 0;
    height: 100%;
    width: 100%;
  }

  &-image {
    position: static;
    width: 100%;
    height: 100%;
    transform: none;
    object-fit: cover;
    z-index: 1;
  }

  &-play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px;
    opacity: 0.5;
    transition: opacity 0.2s;
    z-index: 6;
    cursor: pointer;
    fill: rgba(255, 255, 255, 0.8);
    display: inline;

    &-close {
      z-index: 3;
      width: 30px;
      height: 30px;
      position: absolute;
      right: 35px;
      top: 70px;
      cursor: pointer;
    }

    circle,
    path {
      transition: all 0.2s;
    }

    &-white {

      circle {
        stroke: $color-white;
      }

      path {
        fill: $color-white;
      }
    }

    &-gray {

      circle {
        stroke: $color-gray-85;
      }

      path {
        fill: $color-gray-85;
      }
    }
  }

  &__pause {
    fill: rgba(255, 255, 255, 0.8);
  }

  &__content {
    display: flex;
    flex-direction: column;
    height: 100%;

    .g__copy {
      @include breakpoint(sm) {
        padding: 0 1.5rem;
      }
      margin: 0 0 1rem;
    }

    .heading,
    .heading-only {

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        @include breakpoint(sm) {
          padding: 0 1.5rem;
        }
      }
    }

    .heading {

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin: 1rem 0 0;
      }
    }

    .heading-only {

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin: 1rem 0;
      }
    }
  }

  &__controls {
    height: 30px;
    width: 30px;
    position: absolute;
    top: 0.5em;
    right: 0.5em;
    z-index: +1;
    @include breakpoint(sm) {
      height: 40px;
      width: 40px;
      top: 1em;
      right: 1em;
    }
  }

  &__video {
    top: 0;
    left: 0;
    z-index: 2;
    margin: 0;
    object-fit: cover;
    width: 100%;
    pointer-events: auto;
    height: 100%;
  }
}

.single-video,
.g__video-banner--iframe {
  max-height: 455px;
  height: 100vh;
}
